// Re-skin shadcn de packages/hce/src/hce/licenciaHce/BannerModoConsulta.tsx
// — misma lógica de estado (obtenerEstadoLicenciaHce), solo cambia la UI.
// Esto es UX, no el enforcement real (ver lib/audit/modoConsulta.ts).
import { Lock } from 'lucide-react';
import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMedplum } from '@medplum/react-hooks';
import { useNavigate } from 'react-router';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';
import { Button } from './ui/button';
import { obtenerEstadoLicenciaHce, type EstadoLicenciaHce } from '../lib/audit/modoConsulta';

const DIAS_MODO_CONSULTA = 15;

export function BannerModoConsulta(): JSX.Element | null {
  const { t } = useTranslation();
  const medplum = useMedplum();
  // Navegación interna (2026-09-13): antes `window.location.href =
  // '/hce/licencia/acta'` mandaba al legado packages/hce — y desde el
  // subdominio del consultorio esa ruta caía en la ficha de un "paciente"
  // con id "hce" (bug real: no se podía firmar el Acta). Ver LicenciaActaPage.
  const navigate = useNavigate();
  const irAFirmarActa = (): void => void navigate('/licencia/acta');
  const [estado, setEstado] = useState<EstadoLicenciaHce | undefined>(undefined);

  useEffect(() => {
    let cancelado = false;
    obtenerEstadoLicenciaHce(medplum)
      .then((e) => {
        if (!cancelado) setEstado(e);
      })
      .catch(() => {
        if (!cancelado) setEstado({ estado: 'vigente' });
      });
    return () => {
      cancelado = true;
    };
  }, [medplum]);

  if (!estado || estado.estado === 'vigente') {
    return null;
  }

  if (estado.estado === 'modo-consulta') {
    const desde = estado.modoConsultaDesde ? Date.parse(estado.modoConsultaDesde) : Number.NaN;
    const diasRestantes = Number.isNaN(desde) ? undefined : Math.max(0, Math.ceil(DIAS_MODO_CONSULTA - (Date.now() - desde) / 86_400_000));
    return (
      <Alert variant="orange" className="rounded-none border-x-0 border-t-0">
        <Lock />
        <AlertTitle>{t('licenciaHce.banner.modoConsultaTitulo')}</AlertTitle>
        <AlertDescription>
          <p>{diasRestantes !== undefined ? t('licenciaHce.banner.modoConsultaDetalle', { dias: diasRestantes }) : t('licenciaHce.banner.modoConsultaVencidoDetalle')}</p>
          <Button size="sm" variant="outline" className="mt-1 border-amber-400 text-amber-900 hover:bg-amber-100" onClick={irAFirmarActa}>
            {t('licenciaHce.banner.firmarActaBoton')}
          </Button>
        </AlertDescription>
      </Alert>
    );
  }

  if (estado.estado === 'custodia') {
    return (
      <Alert variant="orange" className="rounded-none border-x-0 border-t-0">
        <Lock />
        <AlertTitle>{t('licenciaHce.banner.custodiaTitulo')}</AlertTitle>
        <AlertDescription>{t('licenciaHce.banner.custodiaDetalle', { fecha: estado.custodiaHasta ?? '' })}</AlertDescription>
      </Alert>
    );
  }

  return (
    <Alert variant="red" className="rounded-none border-x-0 border-t-0">
      <Lock />
      <AlertTitle>{t('licenciaHce.banner.bloqueoTitulo')}</AlertTitle>
      <AlertDescription>{t('licenciaHce.banner.bloqueoDetalle')}</AlertDescription>
    </Alert>
  );
}
